export default "__VITE_ASSET__BIFBOIAE__"